import SubHeader from "./SubHeader"

export default  SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/SubHeader/index.js